import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { Box, IconButton, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import type { FC } from "react";
import { INK, NEUTRAL } from "../../../theme/tokens";

interface PaginationControlsProps {
	currentPage: number;
	totalPages: number;
	onPrevious: () => void;
	onNext: () => void;
}

export const PaginationControls: FC<PaginationControlsProps> = ({ currentPage, totalPages, onPrevious, onNext }) => {
	const theme = useTheme();
	return (
		<Box
			data-testid="schedule-pagination"
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				gap: 2,
				p: 2,
				backgroundColor: NEUTRAL[50],
				borderRadius: "4px",
			}}
		>
			<IconButton
				data-testid="schedule-pagination-previous"
				onClick={onPrevious}
				disabled={currentPage === 1}
				sx={{
					color: theme.palette.primary.dark,
					"&:disabled": {
						color: INK.DISABLED,
					},
					"&:hover:not(:disabled)": {
						backgroundColor: alpha(theme.palette.primary.dark, 0.1),
					},
				}}
			>
				<ArrowBackIos fontSize="small" />
			</IconButton>

			<Typography
				sx={{
					color: theme.palette.primary.dark,
					fontSize: "0.875rem",
					minWidth: "150px",
					textAlign: "center",
				}}
			>
				Page {currentPage} of {totalPages}
			</Typography>

			<IconButton
				data-testid="schedule-pagination-next"
				onClick={onNext}
				disabled={currentPage === totalPages}
				sx={{
					color: theme.palette.primary.dark,
					"&:disabled": {
						color: INK.DISABLED,
					},
					"&:hover:not(:disabled)": {
						backgroundColor: alpha(theme.palette.primary.dark, 0.1),
					},
				}}
			>
				<ArrowForwardIos fontSize="small" />
			</IconButton>
		</Box>
	);
};
